const Footer = () => {
  return <div className="footer">Copyrights: 2021- Riskoncise</div>;
};

export default Footer;
